import { useLocation } from 'react-router-dom';
import { useZoomStore } from '@/shared/store/zoomStore';
import { pageLabelForPath } from '@/components/layout/nav-config';
import { IconStar, IconStarFilled } from '@/components/ui/Icon';
import { useFavoritesStore } from './useFavoritesStore';
import { resolveFavoriteContext, favoriteKey } from './resolveFavoriteContext';

export function FavoriteStar() {
  const { pathname } = useLocation();
  const currentLabel = useZoomStore((s) => s.currentLabel);
  const favorites = useFavoritesStore((s) => s.favorites);
  const add = useFavoritesStore((s) => s.add);
  const remove = useFavoritesStore((s) => s.remove);

  // pageLabel: "Section · Subtab" from nav-config, for route favorites.
  const pageLabel = pageLabelForPath(pathname);

  const ctx = resolveFavoriteContext(pathname, currentLabel, pageLabel);
  const key = favoriteKey(ctx);
  const existing = favorites.find((f) => favoriteKey(f) === key);
  const isOn = Boolean(existing);

  const toggle = () => { if (existing) void remove(existing.id); else void add(ctx); };

  return (
    <button
      type="button"
      onClick={toggle}
      title={isOn ? 'Remove from favorites' : 'Add to favorites'}
      aria-pressed={isOn}
      className="inline-flex items-center justify-center h-6 w-6 rounded-md text-muted hover:text-amber-500 transition-colors"
    >
      {isOn ? <IconStarFilled size={14} className="text-amber-500" /> : <IconStar size={14} />}
    </button>
  );
}
